package ai.jessie.web.pages.registration

import ai.jessie.web.theme.entryFrame
import ai.jessie.web.theme.linkButton
import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Page
@Composable
fun neutralPage() {
    entryFrame("Registrierung nicht abgeschlossen", authenticationRequired = true) {
        P { Text("Die Registrierung konnte über diesen Weg nicht abgeschlossen werden.") }
        P { linkButton("Zur Startseite", "/") }
    }
}
